<template>
  <nav
    class="navbar flex items-center justify-between px-10 py-4 text-gray-900 sm:px-20"
    style="background-color: #FFF;"
  >
    <div class="flex items-center">
      <a href="https://youtilpromo.ro/" title="Youtil Promo Logo" aria-describedby="desc"><img :src="logoSrc" alt="Youtil Promo Logo" class="w-[130px] max-md:w-[120px]" /></a>
      <div id="desc" style="display:none">Youtil Promo Logo</div>
    </div>
    <div class="flex gap-x-10 items-center">
      <div class="md:flex items-center hidden gap-x-10">
        <a
          class="text-gray-900 hover:text-gray-500 duration-200"
          href="/castigatori"
          target="_self"
        >
          {{ $t('Winners') }}
        </a>
        <template v-if="campaignStore.activeCampaign">
          <a
            v-if="campaignStore.activeCampaign.retailerPage"
            class="text-gray-900 hover:text-gray-500 uppercase duration-200"
            :href="`${campaignStore.activeCampaign.retailerPage}?_=${new Date().getTime()}`"
            target="_blank"
          >
            {{ $t('Participating Stores') }}
          </a>
          <a
            class="text-gray-900 hover:text-gray-500 uppercase duration-200"
            :href="`${campaignStore.activeCampaign.tnc}?_=${new Date().getTime()}`"
            target="_blank"
          >
            {{ $t('Terms') }}
          </a>
          <a
            v-if="campaignStore.activeCampaign.type != 'raffle'"
            class="text-gray-900 hover:text-gray-500 uppercase duration-200"
            :href="campaignStore.activeCampaign.faq"
          >
            {{ $t('FAQ') }}
          </a>
        </template>
        <div v-if="!auth0 || !auth0.isAuthenticated" class="flex">
          <button class="flex flex-nowrap items-center gap-3 font-bold" @click="goToLoginPage" aria-label="Login">
            <UserCircle :size="32" color="#288566" />
            <span class="md:flex hidden">{{ $t('LOGIN') }}</span>
          </button>
        </div>
        <div v-else class="flex items-center gap-x-4">
          <button class="flex gap-2 items-center" @click="goToProfilePage" aria-label="Profile">
             <UserCircle :size="32" color="#288566" />
            {{ userName }}
          </button>
          <button @click="logout_" aria-label="Logout">
            <LogOut :size="28" color="#B90B0B" />
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="isMenuOpen"
      class="fixed inset-0 bg-black bg-opacity-50 transition-opacity z-10"
      @click="closeMenu"
    ></div>
    <transition name="menu">
      <div
        v-if="isMenuOpen"
        class="md:hidden absolute top-0 right-0 h-screen w-3/4 bg-white text-black flex flex-col p-6 duration-300 transition z-20"
      >
        <button
          class="w-full flex justify-end mb-2"
          @click="toggleMenu"
          aria-label="Close Menu"
        >
          <X :size="32" />
        </button>
        <div class="flex flex-col gap-y-4">
          <div v-if="!auth0 || !auth0.isAuthenticated" class="flex">
            <button class="flex flex-nowrap items-center gap-3 font-bold" @click="handleMobileLogin" aria-label="Login">
              <UserCircle :size="32" color="#288566" />
              <span class="flex">{{ $t('LOGIN') }}</span>
            </button>
          </div>
          <div v-else class="flex items-center gap-x-4">
            <button class="flex gap-2 items-center" @click="handleMobileProfile" aria-label="Profile">
              <UserCircle :size="32" color="#288566" />
            {{ userName }}
            </button>
            <button @click="handleMobileLogout" aria-label="Logout">
              <LogOut :size="28" color="#B90B0B" />
            </button>
          </div>
          <a
            class="text-gray-900 hover:text-gray-500"
            href="/castigatori"
            target="_self"
            @click="closeMenu"
          >
            {{ $t('Winners') }}
          </a>
          <template v-if="campaignStore.activeCampaign">
            <a
              v-if="campaignStore.activeCampaign.retailerPage"
              class="text-gray-900 hover:text-gray-500 uppercase"
              :href="`${campaignStore.activeCampaign.retailerPage}?_=${new Date().getTime()}`"
              target="_blank"
              @click="closeMenu"
            >
              {{ $t('Participating Stores') }}
            </a>
            <a
              class="text-gray-900 hover:text-gray-500 uppercase"
              :href="`${campaignStore.activeCampaign.tnc}?_=${new Date().getTime()}`"
              target="_blank"
              @click="closeMenu"
            >
              {{ $t('Terms') }}
            </a>
            <a
              v-if="campaignStore.activeCampaign.type != 'raffle'"
              class="text-gray-900 hover:text-gray-500 uppercase"
              :href="campaignStore.activeCampaign.faq"
              @click="closeMenu"
            >
              {{ $t('FAQ') }}
            </a>
          </template>
        </div>
      </div>
    </transition>
    <div class="md:hidden flex items-center">
      <button
        class="text-gray-900 hover:text-gray-900 z-10"
        @click="toggleMenu"
        aria-label="Toggle Menu"
      >
        <Menu :size="32" />
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'navbar-component',
  inheritAttrs: false,
  customOptions: {}
}
</script>
<script setup>
import { ref, watch, inject, computed, onMounted, onUnmounted  } from 'vue'
import { useCampaignStore, useAuthStore } from '@/stores'
import VueCookies from 'vue-cookies'
import { UserCircle, Menu, LogOut, X } from 'lucide-vue-next'
import logoSrc from '@/assets/navbar/logo.svg'
const campaignStore = useCampaignStore()
const authStore = useAuthStore()
const auth0 = inject('auth')

const userName = computed(() => {
  let userInfo = authStore.user
  if (!userInfo) userInfo = VueCookies.get('oktaUser')
  return userInfo ? `${userInfo.firstName} ${userInfo.lastName}` : "";
})

const goToLoginPage = async () => {
  // Auth0 login
  try {
    await auth0.loginWithRedirect({
        appState: {
          targetUrl: `/`
        }
      });
  } catch (error) {
    console.error('Navbar login error:', error);
  }
}

const goToProfilePage = () => {
  if (!auth0 || !auth0.isAuthenticated) return
  // Go to youtilpromo profile page and add flag if authenticated via okta
  window.open(`https://youtilpromo.ro/Selecteaza?login_prof=${auth0.isAuthenticated}`, '_self');
}

// Mobile menu handlers that close the menu after action
const handleMobileLogin = () => {
  closeMenu()
  goToLoginPage()
}

const handleMobileProfile = () => {
  closeMenu()
  goToProfilePage()
}

const handleMobileLogout = async () => {
  closeMenu()
  await logout_()
}

const isMenuOpen = ref(false)

watch(isMenuOpen, newVal => {
  let bodyOverflow = ''
  if (newVal) bodyOverflow = 'hidden'
  document.body.style.overflow = bodyOverflow
})

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
}

const closeMenu = () => {
  isMenuOpen.value = false
}

// Close menu when clicking outside or pressing escape
const handleKeyDown = (e) => {
  if (e.key === 'Escape' && isMenuOpen.value) {
    closeMenu()
  }
}

onMounted(() => {
  document.addEventListener('keydown', handleKeyDown)
})

onUnmounted(() => {
  document.removeEventListener('keydown', handleKeyDown)
})

const logout_ = async () => {
  // Okta logout
  try {
    // Logout from BE first then okta
    await authStore.logout()
    auth0.logout({ logoutParams: { returnTo: window.location.origin } });
  } catch (error) {
    console.error(error);
  }
}

</script>

<style scoped lang="scss">
.navbar {
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
}

.menu-enter-active,
.menu-leave-active {
  transition: transform 0.3s ease;
}

.menu-enter-to {
  transform: translateX(10px);
}

.menu-leave-to {
  transform: translateX(100%);
}
</style>
